export const COUNTRY_TIMEZONE_MAP: { [key: string]: string } = {
  // Europe
  'France': 'Europe/Paris',
  'Germany': 'Europe/Berlin',
  'United Kingdom': 'Europe/London',
  'Spain': 'Europe/Madrid',
  'Italy': 'Europe/Rome',
  'Belgium': 'Europe/Brussels',
  'Netherlands': 'Europe/Amsterdam',
  'Switzerland': 'Europe/Zurich',
  'Austria': 'Europe/Vienna',
  'Poland': 'Europe/Warsaw',
  'Sweden': 'Europe/Stockholm',
  'Norway': 'Europe/Oslo',
  'Denmark': 'Europe/Copenhagen',
  'Finland': 'Europe/Helsinki',
  'Greece': 'Europe/Athens',
  'Czech Republic': 'Europe/Prague',
  'Portugal': 'Europe/Lisbon',
  'Ireland': 'Europe/Dublin',
  'Romania': 'Europe/Bucharest',
  'Hungary': 'Europe/Budapest',
  'Slovakia': 'Europe/Bratislava',
  'Slovenia': 'Europe/Ljubljana',
  'Croatia': 'Europe/Zagreb',
  'Serbia': 'Europe/Belgrade',
  'Bulgaria': 'Europe/Sofia',
  'Lithuania': 'Europe/Vilnius',
  'Latvia': 'Europe/Riga',
  'Estonia': 'Europe/Tallinn',
  'Luxembourg': 'Europe/Luxembourg',
  'Malta': 'Europe/Malta',
  'Cyprus': 'Asia/Nicosia',
  'Andorra': 'Europe/Andorra',
  'Belarus': 'Europe/Minsk',
  'Bosnia and Herzegovina': 'Europe/Sarajevo',
  'Moldova': 'Europe/Chisinau',
  'North Macedonia': 'Europe/Skopje',
  'Albania': 'Europe/Tirane',
  'Montenegro': 'Europe/Podgorica',
  'Ukraine': 'Europe/Kiev',
  'Russia': 'Europe/Moscow',
  'Iceland': 'Atlantic/Reykjavik',
  'Liechtenstein': 'Europe/Vaduz',
  'Monaco': 'Europe/Monaco',
  'San Marino': 'Europe/San_Marino',
  'Vatican': 'Europe/Vatican',
  'Faroe Islands': 'Atlantic/Faroe',
  'Azores': 'Atlantic/Azores',
  'Madeira': 'Atlantic/Madeira',
  'Gibraltar': 'Europe/Gibraltar',
  'Guernsey': 'Europe/Guernsey',
  'Jersey': 'Europe/Jersey',
  'Isle of Man': 'Europe/Isle_of_Man',

  // Americas - North America
  'United States': 'America/New_York',
  'Canada': 'America/Toronto',
  'Mexico': 'America/Mexico_City',
  'Greenland': 'America/Godthab',

  // Americas - Central America & Caribbean
  'Costa Rica': 'America/Costa_Rica',
  'Panama': 'America/Panama',
  'Guatemala': 'America/Guatemala',
  'Honduras': 'America/Tegucigalpa',
  'Nicaragua': 'America/Managua',
  'El Salvador': 'America/El_Salvador',
  'Belize': 'America/Belize',
  'Jamaica': 'America/Jamaica',
  'Bahamas': 'America/Nassau',
  'Cuba': 'America/Havana',
  'Dominican Republic': 'America/Santo_Domingo',
  'Haiti': 'America/Port-au-Prince',
  'Puerto Rico': 'America/Puerto_Rico',
  'Trinidad and Tobago': 'America/Port_of_Spain',
  'Barbados': 'America/Barbados',
  'Belmopan': 'America/Belize',

  // Americas - South America
  'Brazil': 'America/Sao_Paulo',
  'Argentina': 'America/Argentina/Buenos_Aires',
  'Chile': 'America/Santiago',
  'Colombia': 'America/Bogota',
  'Peru': 'America/Lima',
  'Venezuela': 'America/Caracas',
  'Ecuador': 'America/Guayaquil',
  'Bolivia': 'America/La_Paz',
  'Paraguay': 'America/Asuncion',
  'Uruguay': 'America/Montevideo',
  'Guyana': 'America/Guyana',
  'Suriname': 'America/Paramaribo',
  'French Guiana': 'America/Cayenne',

  // Asia - East Asia
  'Japan': 'Asia/Tokyo',
  'China': 'Asia/Shanghai',
  'South Korea': 'Asia/Seoul',
  'Taiwan': 'Asia/Taipei',
  'Hong Kong': 'Asia/Hong_Kong',
  'Macau': 'Asia/Macau',
  'Mongolia': 'Asia/Ulaanbaatar',

  // Asia - Southeast Asia
  'Thailand': 'Asia/Bangkok',
  'Vietnam': 'Asia/Ho_Chi_Minh',
  'Indonesia': 'Asia/Jakarta',
  'Philippines': 'Asia/Manila',
  'Singapore': 'Asia/Singapore',
  'Malaysia': 'Asia/Kuala_Lumpur',
  'Cambodia': 'Asia/Phnom_Penh',
  'Laos': 'Asia/Vientiane',
  'Myanmar': 'Asia/Yangon',
  'Timor-Leste': 'Asia/Dili',
  'Brunei': 'Asia/Brunei',

  // Asia - South Asia
  'India': 'Asia/Kolkata',
  'Pakistan': 'Asia/Karachi',
  'Bangladesh': 'Asia/Dhaka',
  'Sri Lanka': 'Asia/Colombo',
  'Nepal': 'Asia/Kathmandu',
  'Bhutan': 'Asia/Thimphu',
  'Afghanistan': 'Asia/Kabul',
  'Maldives': 'Indian/Maldives',

  // Asia - Central Asia
  'Kazakhstan': 'Asia/Almaty',
  'Uzbekistan': 'Asia/Tashkent',
  'Tajikistan': 'Asia/Dushanbe',
  'Kyrgyzstan': 'Asia/Bishkek',
  'Turkmenistan': 'Asia/Ashgabat',

  // Asia - Middle East
  'United Arab Emirates': 'Asia/Dubai',
  'Saudi Arabia': 'Asia/Riyadh',
  'Israel': 'Asia/Jerusalem',
  'Palestine': 'Asia/Hebron',
  'Turkey': 'Europe/Istanbul',
  'Iran': 'Asia/Tehran',
  'Iraq': 'Asia/Baghdad',
  'Lebanon': 'Asia/Beirut',
  'Jordan': 'Asia/Amman',
  'Syria': 'Asia/Damascus',
  'Yemen': 'Asia/Aden',
  'Oman': 'Asia/Muscat',
  'Kuwait': 'Asia/Kuwait',
  'Bahrain': 'Asia/Bahrain',
  'Qatar': 'Asia/Qatar',

  // Australia & Oceania
  'Australia': 'Australia/Sydney',
  'New Zealand': 'Pacific/Auckland',
  'Fiji': 'Pacific/Fiji',
  'Samoa': 'Pacific/Apia',
  'Kiribati': 'Pacific/Tarawa',
  'Marshall Islands': 'Pacific/Majuro',
  'Micronesia': 'Pacific/Pohnpei',
  'Nauru': 'Pacific/Nauru',
  'Palau': 'Pacific/Palau',
  'Papua New Guinea': 'Pacific/Port_Moresby',
  'Solomon Islands': 'Pacific/Guadalcanal',
  'Tonga': 'Pacific/Tongatapu',
  'Tuvalu': 'Pacific/Funafuti',
  'Vanuatu': 'Pacific/Efate',
  'Guam': 'Pacific/Guam',
  'Northern Mariana Islands': 'Pacific/Saipan',
  'American Samoa': 'Pacific/Pago_Pago',
  'Wake Island': 'Pacific/Wake',
  'Wallis and Futuna': 'Pacific/Wallis',
  'French Polynesia': 'Pacific/Tahiti',
  'Cook Islands': 'Pacific/Rarotonga',
  'Niue': 'Pacific/Niue',
  'Norfolk Island': 'Pacific/Norfolk',
  'Chatham Islands': 'Pacific/Chatham',
  'Lord Howe Island': 'Australia/Lord_Howe',

  // Africa - North Africa
  'Egypt': 'Africa/Cairo',
  'Morocco': 'Africa/Casablanca',
  'Tunisia': 'Africa/Tunis',
  'Algeria': 'Africa/Algiers',
  'Libya': 'Africa/Tripoli',
  'Sudan': 'Africa/Khartoum',
  'South Sudan': 'Africa/Juba',
  'Western Sahara': 'Africa/El_Aaiun',

  // Africa - West Africa
  'Nigeria': 'Africa/Lagos',
  'Ghana': 'Africa/Accra',
  'Senegal': 'Africa/Dakar',
  'Ivory Coast': 'Africa/Abidjan',
  'Guinea': 'Africa/Conakry',
  'Mali': 'Africa/Bamako',
  'Mauritania': 'Africa/Nouakchott',
  'Burkina Faso': 'Africa/Ouagadougou',
  'Niger': 'Africa/Niamey',
  'Sierra Leone': 'Africa/Freetown',
  'Liberia': 'Africa/Monrovia',
  'Benin': 'Africa/Porto-Novo',
  'Togo': 'Africa/Lome',
  'Gambia': 'Africa/Banjul',
  'Guinea-Bissau': 'Africa/Bissau',
  'Gabon': 'Africa/Libreville',
  'Equatorial Guinea': 'Africa/Malabo',
  'Cameroon': 'Africa/Douala',
  'Central African Republic': 'Africa/Bangui',
  'Sao Tome and Principe': 'Africa/Sao_Tome',
  'Comoros': 'Indian/Comoro',

  // Africa - East Africa
  'Kenya': 'Africa/Nairobi',
  'Ethiopia': 'Africa/Addis_Ababa',
  'Uganda': 'Africa/Kampala',
  'Tanzania': 'Africa/Dar_es_Salaam',
  'Somalia': 'Africa/Mogadishu',
  'Djibouti': 'Africa/Djibouti',
  'Eritrea': 'Africa/Asmara',
  'Madagascar': 'Indian/Antananarivo',
  'Mauritius': 'Indian/Mauritius',
  'Seychelles': 'Indian/Mahe',
  'Reunion': 'Indian/Reunion',
  'Mayotte': 'Indian/Mayotte',

  // Africa - Central Africa
  'Chad': 'Africa/Ndjamena',
  'Congo': 'Africa/Brazzaville',
  'Democratic Republic of the Congo': 'Africa/Kinshasa',
  'Angola': 'Africa/Luanda',
  'Zambia': 'Africa/Lusaka',
  'Zimbabwe': 'Africa/Harare',
  'Malawi': 'Africa/Blantyre',
  'Rwanda': 'Africa/Kigali',
  'Burundi': 'Africa/Bujumbura',

  // Africa - Southern Africa
  'South Africa': 'Africa/Johannesburg',
  'Namibia': 'Africa/Windhoek',
  'Botswana': 'Africa/Gaborone',
  'Lesotho': 'Africa/Maseru',
  'Eswatini': 'Africa/Mbabane',
};

export const TIMEZONES: string[] = Array.from(
  new Set(Object.values(COUNTRY_TIMEZONE_MAP))
).sort();